exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor_wrap[data-v-1ea823ae]{height:361px;background:#ededed}.editor_wrap .title_wrap[data-v-1ea823ae]{height:42px;border-top:1px solid #c6c6c6;border-bottom:1px solid #c6c6c6}.editor_wrap .title_wrap div[data-v-1ea823ae]{float:left;height:100%;line-height:42px;padding:0 24px;cursor:pointer;border-bottom:2px solid #ededed;font-size:14px}.editor_wrap .title_wrap div a[data-v-1ea823ae]{font-size:14px;color:#000}.editor_wrap .title_wrap div[data-v-1ea823ae]:hover,.editor_wrap .title_wrap div:hover>a[data-v-1ea823ae]{color:#ea6e52}", ""]);

// exports
